<template>
    <div v-if="opened" class="popup-container">
        <div class="popup">
            <h3>{{ title }}</h3>
            <button class="close" @click="$emit('close')">x</button>
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Popup",
        props: {
            title: String,
            opened: Boolean
        }
    }
</script>
<style lang="scss">
    .popup-container {
        height: 100vh;
        width: 100vw;
        background-color: rgba(0,0,0,0.16);
        top: 0;
        left: 0;
        position: fixed;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;

        .popup {
            width: 600px;
            min-height: 300px;
            max-height: 80vh;
            overflow: scroll;
            padding: 30px;
            background-color: #fff;
            border-radius: 10px;
            position: relative;
            box-shadow: 0 5px 20px rgba(0,0,0,0.3);

            .close {
                position: absolute;
                top: 10px;
                right: 10px;
                background-color: red;
                border: 0;
                height: 15px;
                width: 15px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                font-size: 10px;
                cursor: pointer;
            }
        }
    }
</style>
